import { Component, Input } from '@angular/core';
import { Css, patchCss } from '../../functions/ovverideCss';

@Component({
  selector: 'app-no-element',
  templateUrl: './no-element.component.html',
  styleUrls: ['./no-element.component.scss'],
})
export class NoElementComponent {

  @Input() isDocument: boolean = false;


  get emptyImage(): string {
    return sessionStorage.getItem('theme') === 'dark'
      ? '../../../assets/images/empty-state-dark.svg'
      : '../../../assets/images/empty-state-light.svg';
  }

  myTableConfig = {
    tableWidthPercentage: true,
    tableHeader: {
      hiddenHeader: true,
      tableCellsHeader: [
        { text: '', columnId: 'empty', columnWidth: '100%' },
      ],
    },
    tableRows: [],
    tableAriaLabel: 'table aria label',
    navigationAriaLabel:
      'usa le frecce Su, Giù, Sinistra, Destra per navigare la tabella, Enter per interagire con una cella, Tab per navigare i sottomenu, Esc per chiudere',
  };

}
